'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';

import {invitationModel} from "../../models/invitationmodel.js";

export class InvitationListSiteCtrl extends ListCtrl
{

	constructor($scope, $http, $filter, $timeout, $locale, jsDataService){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.cfgAddUrl = this.jsDataService.get('cfgAddUrl', '');
		this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
	}

	storageNames = {
		query: 'InvitationsListCtrlQuery'
	};
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new invitationModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
//		switch(col){
//			case 'duration_extension':
//				if(typeof(this.classif.yesno) !== 'undefined'){
//					let v = this.$filter('filter')(this.classif.yesno, {id: row[col]}, true);
//					if(v.length > 0){
//						return v[0].title;
//					}
//				}
//		}
		if(row instanceof invitationModel){
			return row.getValue(col);
		}
		return row[col];
	}
	
	getFooterData(col){
		if(typeof(this.columnsData.footer[col]) !== 'undefined'){
			switch(col){
				case 'budget':
				case 'applications_amount':
					return this.$filter('currency')(this.columnsData.footer[col].value);
			}
			return this.columnsData.footer[col].value;
		}
		return '';
	}

	createNew(){
		const url = this.jsDataService.get('cfgAddUrl', '');
		if(url !== ''){
			this.$scope.basicHttpConfigProcess({
				url: url,
				method: 'GET',
			});
		}
	}
	
	exportList(){
		const query = new URLSearchParams({
			filters: JSON.stringify(this.query.filters),
			limit: this.query.limit,
			page: this.query.page,
			order: this.query.order,
		});
		
		const ts = new Date().toISOString().substring(0, 19).replace(/-|:|T/g, '');
		
		const a = document.createElement('a');
		a.style.display = 'none';
		a.href = `${this.cfgExportUrl}?${query.toString()}`;
		a.download = `Calls_${ts}.xlsx`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
	
	
}


